import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";

const ProjectList = Loadable(
  lazy(() =>
    import("./ProjectTabs").then(({ ProjectTabs }) => ({
      default: ProjectTabs,
    })),
  ),
);
const Projects = Loadable(
  lazy(() =>
    import("./ProjectList").then(({ ProjectList }) => ({
      default: ProjectList,
    })),
  ),
);
const ProjectTask = Loadable(
  lazy(() =>
    import("./projectTaskList/ProjectTaskTabs").then(({ ProjectTaskTabs }) => ({
      default: ProjectTaskTabs,
    })),
  ),
);
const ManageProject = Loadable(
  lazy(() =>
    import("./ManageProject").then(({ ManageProject }) => ({
      default: ManageProject,
    })),
  ),
);

export const projectRoutes = [
  {
    path: "/projects",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.PROJECT]}>
        <Projects />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/project-list",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.PROJECT]}>
        <ProjectList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/project/task/:taskId",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.PROJECT]}>
        <ProjectTask />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/project/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.PROJECT]}>
        <ManageProject />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/project/manage/:projectUUID",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.PROJECT]}>
        <ManageProject />
      </AuthorizedRoute>
    ),
  },
];
